/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFollowAktsResponseItems
 */
export interface GetFollowAktsResponseItems {
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsResponseItems
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsResponseItems
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    subject: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFollowAktsResponseItems
     */
    isBold: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    resp: string;
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsResponseItems
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetFollowAktsResponseItems
     */
    hasattachment: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    aktname: string;
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsResponseItems
     */
    akttype: number;
    /**
     * 
     * @type {string}
     * @memberof GetFollowAktsResponseItems
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsResponseItems
     */
    todotype: number;
}

export function GetFollowAktsResponseItemsFromJSON(json: any): GetFollowAktsResponseItems {
    return GetFollowAktsResponseItemsFromJSONTyped(json, false);
}

export function GetFollowAktsResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFollowAktsResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'aktid': json['aktid'],
        'date': json['date'],
        'subject': json['subject'],
        'isBold': json['isBold'],
        'icon': json['icon'],
        'color': json['color'],
        'resp': json['resp'],
        'priority': json['priority'],
        'hasattachment': json['hasattachment'],
        'aktname': json['aktname'],
        'akttype': json['akttype'],
        'summary': json['summary'],
        'todotype': json['todotype'],
    };
}

export function GetFollowAktsResponseItemsToJSON(value?: GetFollowAktsResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'aktid': value.aktid,
        'date': value.date,
        'subject': value.subject,
        'isBold': value.isBold,
        'icon': value.icon,
        'color': value.color,
        'resp': value.resp,
        'priority': value.priority,
        'hasattachment': value.hasattachment,
        'aktname': value.aktname,
        'akttype': value.akttype,
        'summary': value.summary,
        'todotype': value.todotype,
    };
}


